import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { notification } from 'antd'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { giftCreditsActions, GiftCreditsActions } from './gift-credits.actions'
import { GiftCreditsState } from './gift-credits.reducer'
import { genericError } from 'src/utils/notifications.utils'
import * as UUID from 'uuid'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

interface Action$ extends ActionsObservable<GiftCreditsActions> {}
interface State$ extends StateObservable<GiftCreditsState> {}

const loadCreditsSummary = (dsService: DSService) => (p: { [startFetch]: string; token: string; companyId: string }) =>
  from(
    dsService.getCreditsSummary(p.token, p.companyId).map(creditsSummaryOpt =>
      pipe(
        creditsSummaryOpt,
        O.fold(
          () => {
            genericError()
            return giftCreditsActions.LoadCreditsFailure({ [stopFetch]: p[startFetch] })
          },
          creditsSummary =>
            giftCreditsActions.LoadCreditsSuccess({
              [stopFetch]: p[startFetch],
              credits: creditsSummary.result
            })
        )
      )
    )
  )

const giftCredits = (dsService: DSService) => (p: {
  token: string
  companyId: string
  testId: string
  credits: number
  [startFetch]: string
}) =>
  from(
    dsService
      .giftCredits({ token: p.token, testId: p.testId, companyId: p.companyId, credits: p.credits })
      .map(resOpt =>
        pipe(
          resOpt,
          O.fold(
            () => {
              notification.error({
                message: 'Erreur',
                description: "Erreur lors de l'ajout de crédits"
              })
              return giftCreditsActions.GiftCreditsFailure({ [stopFetch]: p[startFetch] })
            },
            _ => {
              notification.success({
                message: 'Crédits offerts',
                description: "Les crédits ont bien été ajoutés au solde de l'entreprise"
              })
              giftCreditsActions.LoadCredits({
                [startFetch]: UUID.v4(),
                companyId: p.companyId,
                token: p.token
              })
              return giftCreditsActions.GiftCreditsSuccess({ [stopFetch]: p[startFetch] })
            }
          )
        )
      )
  )

export const loadCreditsSummaryEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(giftCreditsActions.is.LoadCredits),
    mergeMap(loadCreditsSummary(deps.dsService))
  )

export const giftCreditsEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(giftCreditsActions.is.GiftCredits),
    mergeMap(giftCredits(deps.dsService))
  )

export const giftCreditsEpics = combineEpics(loadCreditsSummaryEpic, giftCreditsEpic)



// WEBPACK FOOTER //
// ./src/credits-components/gift-credits/gift-credits.epics.ts